export default class ResourcesSearch {
	constructor() {
		this.filters = $('#resource-search-form');
		this.results = $('#resource-search-results');
		this.reset = $('[type="reset"]');
		this.data = {};
		this.layout = 'list'; // list, grid
		this.orderby = 'featured'; // title, date, featured
		this.order = 'desc';
		this.searchTimeout = 0;

		this.init();
	}

	init() {
		if( ! this.filters.length || ! this.results.length ) return false;

		// search on form input change
		$(':input', this.filters).on('input', (event) => {
			clearTimeout(this.searchTimeout);
			this.searchTimeout = setTimeout(()=>{
				this.search();
			}, 500);
		});

		// pagination controls
		$(this.results).on('click', '.page-link', (event) => {
			event.preventDefault();
			var page = $(event.currentTarget).data('page');
			this.search(page);
		});

		// layout select
		$('.resources-layout-option').on('click', (event) => {
			event.preventDefault();
			$('.resources-layout-option').removeClass('active');
			var $option = $(event.currentTarget);
			$option.addClass('active');
			this.setLayout($option.data('layout'));
			this.search();
		});

		// sort
		$('#resource-search-sort').change(event => {
			this.setOrderBy($(event.currentTarget).val());
			this.search();
		});

		// reset button
		this.reset.on('click', (event) => {
			$(":checkbox", this.filters).attr('checked', false);
			$(':input[name="s"]', this.filters).val('');
			this.search();
		});

		this.search();
	}

	search(page=1) {
		var $categories = $(':input[name="resource-category[]"]:checked', this.filters);
		var $formats = $(':input[name="resource-format[]"]:checked', this.filters);
		var $stages = $(':input[name="stage[]"]:checked', this.filters);
		var keywords = $(':input[name="s"]', this.filters).val();

		var categories = [];
		var formats = [];
		var stages = [];

		// empty the results panel but maintain its height
		var h = $(this.results).height();

		$(this.results)
			.height(h)
			.addClass('loading')
			.append('<div class="ajax-results-spinner"><span class="loading-icon fas fa-spinner fa-spin"></span> Loading...</div>');

		$categories.each((n, item)=>{
			categories.push(item.value);
		});

		$formats.each((n, item)=>{
			formats.push(item.value);
		});

		$stages.each((n, item)=>{
			stages.push(item.value);
		});

		$.ajax({
			method: 'post',
			url: window.ff_settings.main_site_url + '/wp-json/dsa/v1/resources?html=1',
			dataType: 'json',
			data: {
				categories: categories.join(','),
				formats: formats.join(','),
				stages: stages.join(','),
				keywords: keywords,
				layout: this.layout,
				orderby: this.orderby,
				order: this.order,
				// pagination
				page: page
			}
		}).done( (response) => {
			// do something with data
			this.data = response;
			$(this.results)
				.html(response.html)
				.removeClass('loading')
				.removeAttr('style');
		});
	}

	setLayout( layout ) {
		if( ['grid', 'list'].indexOf(layout) >= 0 ) {
			this.layout = layout;
		}
	}

	setOrderBy( field ) {
		if( ['featured', 'title', 'date'].indexOf(field) >= 0 ) {
			this.orderby = field;
		}

		this.order = this.orderby == 'title' ? 'asc'  : 'desc';
	}
}